import { useEffect, useState } from "react";
import { Annotation, SourceFile } from "../../../types";
import { validateLinks } from "../../../utils/ValidateLinks";
import { validateWalkthrough } from "../../../utils/ValidateWalkthrough";
import { DoublyLinkedList } from "../linked-list/DoublyLinkedList";
import { AnnotationParser } from "../parsers/AnnotationParser";
import { WalkthroughLoader } from "../WalkthroughLoader";

export interface WalkthroughProps {
  sandboxName?: string;
  files?: SourceFile[];
}

export const useWalkthroughParser = ({ sandboxName, files }: WalkthroughProps) => {
  const [steps, setSteps] = useState<DoublyLinkedList<Annotation>>()

  useEffect(() => {
    if (!files || !files.length)
      return;

    const walkthroughFile = files.find((file) => file.filePath === "/walkthrough.md");

    if (!walkthroughFile || walkthroughFile.content === undefined || walkthroughFile.deleted) {
      setSteps(undefined);
      return;
    }

    validateWalkthrough(walkthroughFile.content);
    validateLinks(walkthroughFile.content);

    const steps = AnnotationParser.deserialize(walkthroughFile.content, sandboxName);
    const annotations = WalkthroughLoader.createWalkthroughAnnotations(steps, files);

    const newSteps = new DoublyLinkedList<Annotation>();
    annotations.forEach((step) => {
      newSteps.push({ ...step, filePath: step.filePath });
    });

    setSteps(newSteps);

  }, [files]);

  return steps;
}